import UsersRoute from './UsersRoute';

export default UsersRoute;
